var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetchWithTimeout } from "@/utils";
export const fetchPrefillData = (prefillUrl, jwt) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetchWithTimeout(prefillUrl, {
            method: "GET",
            mode: "cors",
            credentials: "same-origin",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${jwt}`,
            },
        }, 2000);
        if (!response.ok) {
            return null;
        }
        return response.json();
    }
    catch (error) {
        return null;
    }
});
